// Port of api/fuel/app/classes/filter/search/games/sorts/query/collection/wishlist.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'wishlist.priority',
	post: false,
	require: function(config, filter) { return sorted('wishlist.priority', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('c.collection_wishlist_priority', sortReverse('wishlist.priority', filter), sortPriority('wishlist.priority', filter))
	}
}
